import { Receipt } from "lucide-react";

export default function RefundPage() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12 md:px-10 md:py-16">
      <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Legal</p>
      <h1 className="mt-2 font-display text-4xl font-medium tracking-tight">Refund Policy</h1>
      <p className="mt-2 text-sm text-muted-foreground">Last updated: 4 June 2026</p>
      <div className="prose prose-invert mt-8 max-w-none text-sm leading-relaxed text-foreground/90">
        <p><Receipt className="mr-1 inline h-4 w-4 text-primary" /> We want you to be happy. Here's how refunds work.</p>

        <h2 className="mt-6 font-display text-xl">Wallet top-ups</h2>
        <p>Wallet top-ups are refundable within 7 days of the transaction <em>provided</em> the funds have not been spent or withdrawn. Email us at support@zuntria.ai with your order/session ID.</p>

        <h2 className="mt-6 font-display text-xl">Digital services (Hustle Plan, Business Plan, CV, etc.)</h2>
        <p>Because these are AI-generated digital deliverables produced on-demand, refunds are only granted if:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>You did not receive your document/output due to a technical error, OR</li>
          <li>The output is clearly off-topic from what you asked for.</li>
        </ul>
        <p>Refunds for digital services must be requested within 48 hours and include the document ID.</p>

        <h2 className="mt-6 font-display text-xl">Zuntria Premium subscription</h2>
        <p>Premium is non-refundable for the period purchased. You can stop renewing any time — your access continues until the end of your paid period.</p>

        <h2 className="mt-6 font-display text-xl">How to request</h2>
        <p>Email <a className="text-primary underline" href="mailto:support@zuntria.ai">support@zuntria.ai</a> with:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Your account email</li>
          <li>The transaction or order ID</li>
          <li>The reason for the refund</li>
        </ul>
        <p>We respond within 3 business days. Approved refunds go back to your original payment method within 5–10 business days.</p>
      </div>
    </div>
  );
}
